import React, { Component } from 'react';
import { generate } from 'shortid';
import FieldGroup from './FieldGroup';
import { PasswordValidation } from '../../tools/Validations';

class PasswordField extends Component {
  constructor(props) {
    super(props);
    this.ids = {
      password: generate(),
      popover: generate(),
    }
    this.validation = props.validation || new PasswordValidation();
    this.validation.test(props.value);
  }

  render() {
    const {
      focus = false,
      name = "password",
      value = "",
      label = "Password",
      onChange,
      ...otherProps,
    } = this.props;

    return (
      <FieldGroup
        focus={focus}
        id={this.ids.password}
        name={name}
        type="password"
        label={label}
        value={value}
        onChange={this.onChange}
        onBlur={this.validate}
        validation={this.validation}
        placeholder="********"
        {...otherProps} />
    );
  }

  onChange = (e) => {
    let isValid = this.validation.test(e.target.value);
    let onChange = this.props.onChange;
    if (onChange) {
      onChange(e, isValid);
    }
  }
}

export default PasswordField;



// WEBPACK FOOTER //
// ./src/components/FieldGroup/PasswordField.js